import React, { FC, useCallback, useEffect, useState } from "react";
import {
  autoSyncMapping,
  checkSyncStatus,
  createMapping,
  deleteAutoSync,
  getItems,
  syncMapping,
  unmapMapping,
} from "../repositories/ConnectRepository";
import { FilesExplorer } from "./files/FilesExplorer";
import { useNavigate } from "react-router-dom";
import { FullScreenLoader, Loader } from "../Components/Loader";
import { getTCConnection } from "../repositories/TCRepository";
import CssBaseline from "@mui/material/CssBaseline";
import Popup from "./Popup";
import SyncStatus from "./SyncStatus";
import Button from "@mui/material/Button";
import { logOut } from "../utils/AxiosHandlers";
import Select from "react-select";
import { formatDateAndTime, sortDataByNameAndType } from "../utils/FileUtils";
import { Alert, Checkbox, Chip, FormControlLabel } from "@mui/material";
import { Button as CButton } from "./shared/ui-react/Button";

export const Folder: FC = () => {
  const [leftFolders, setLeftFolders] = useState<any[]>([]);
  const [rightFolders, setRightFolders] = useState<any[]>([]);
  const [leftPath, setLeftPath] = useState<string>("");
  const [leftUuid, setLeftUuid] = useState<string>("");
  const [rightPath, setRightPath] = useState<string>("");
  const [rightUuid, setRightUuid] = useState<string>("");
  const [isLeftLoading, setIsLeftLoading] = useState(false);
  const [isRightLoading, setIsRightLoading] = useState(true);
  const [popupLoading, setPopupLoading] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [mapped, setMapped] = useState<boolean>(false);
  const [isSyncing, setIsSyncing] = useState<boolean>(false);
  const [syncWay, setSyncWay] = useState("TC_TO_IK");
  const [autoSyncChecked, setAutoSyncChecked] = useState(false);
  const [delta, setDelta] = useState(60);

  const [showPopup, setShowPopup] = useState(false);
  const [popupMessage, setPopupMessage] = useState("");
  const [popupCallback, setPopupCallback] = useState<string>("");
  const [connection, setConnection] = useState<any>({});

  const [detailsOpen, setDetailsOpen] = useState(false);

  const navigate = useNavigate();

  const fetchConnection = useCallback(() => {
    const connectionUuid = localStorage.getItem("connectionUuid");
    !connectionUuid && navigate("/");

    if (!!connectionUuid) {
      setIsLoading(true);
      getTCConnection(connectionUuid!)
        .then((data) => {
          setConnection(data);
          if (!!data) {
            if (data.isMapped) {
              setMapped(true);
              setLeftPath(data.mapping.infraFolderPath);
              setRightPath(data.mapping.trimbleFolderPath);
              setLeftUuid(data.mapping.infraUuidPath);
              setRightUuid(data.mapping.trimbleFolderUuid);
              if (data.mapping.isMapped === "SYNCING") {
                setIsSyncing(true);
                // setShowPopup(true);
                // setPopupLoading(true);
              }
            } else {
              setMapped(false);
              setLeftPath(data.infraFolderPath);
              setRightPath(data.trimbleFolderPath);
              setLeftUuid(data.infraFolderUuid);
              setRightUuid(data.trimbleFolderUuid);
            }
          }
        })
        .finally(() => setIsLoading(false));
    }
  }, [navigate]);

  // useEffect(() => {
  //   const interval = setInterval(() => {
  //     if (isSyncing) {
  //       checkStatus();
  //     }
  //   }, 5000); // Interval in milliseconds (5 seconds)

  //   return () => {
  //     clearInterval(interval); // Cleanup the interval when the component unmounts
  //   }
  // }, [isSyncing]);

  useEffect(fetchConnection, [fetchConnection]);

  const openPopup = (message: string, callback: string) => {
    setPopupMessage(message);
    setPopupCallback(callback);
    setShowPopup(true);
  };

  const handleOk = () => {
    setPopupLoading(true);

    switch (popupCallback) {
      case "connect":
        connect();
        break;
      case "unmap":
        unmap();
        break;
      case "stop":
        stop();
        break;
    }
  };

  function connect() {
    let lastLeftUUID = "";
    let lastRightUUID = "";
    if (!!leftUuid && !!rightUuid) {
      const leftArray = leftUuid.split("/");
      const rightArray = rightUuid.split("/");

      lastLeftUUID = leftArray[leftArray.length - 1];
      lastRightUUID = rightArray[rightArray.length - 1];
    }

    createMapping(
      connection.uuid,
      lastLeftUUID,
      leftPath,
      lastRightUUID,
      rightPath,
      leftUuid
    )
      .then(() => {
        setShowPopup(false);
        setPopupLoading(false);
        fetchConnection();
      })
      .catch(() => {});
  }

  function checkStatus() {
    checkSyncStatus(connection.uuid).then((res) => {
      if (res.status !== "SYNCING") {
        setIsSyncing(false);

        fetchInfrakitList();
        fetchTrimbleList();
        //  setShowPopup(false);
        //  setPopupLoading(false);
      }
      fetchConnection();
    });
  }

  const sync = (isAutoSync: boolean = false, delta: number) => {
    const promise = isAutoSync
      ? autoSyncMapping(
          connection.uuid,
          connection.mapping.uuid,
          syncWay,
          delta
        )
      : syncMapping(connection.uuid, connection.mapping.uuid, syncWay);

    promise.then(() => {
      setShowPopup(false);
      setPopupLoading(false);
      setIsSyncing(!isAutoSync);
      setAutoSyncChecked(false);
      setDelta(60);
    });
  };

  function unmap() {
    unmapMapping(connection.uuid).then(() => {
      setShowPopup(false);
      setPopupLoading(false);
      fetchConnection();
    });
  }

  function stop() {
    deleteAutoSync(connection.uuid).then(() => {
      setShowPopup(false);
      setPopupLoading(false);
      fetchConnection();
    });
  }

  const fetchInfrakitList = useCallback(() => {
    let lastUUID = "";
    if (!!leftUuid) {
      const uuidArray = leftUuid.split("/");
      lastUUID = uuidArray[uuidArray.length - 1];
    }

    if (connection.uuid) {
      setIsLeftLoading(true);
      getItems(
        connection.uuid,
        lastUUID || connection.infrakit_root_folder_uuid,
        "infrakit"
      )
        .then((res) => setLeftFolders(sortDataByNameAndType(res)))
        .catch(() => {})
        .finally(() => setIsLeftLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leftUuid]);

  useEffect(() => {
    fetchInfrakitList();
  }, [fetchInfrakitList]);

  const fetchTrimbleList = useCallback(() => {
    if (connection.uuid) {
      setIsRightLoading(true);
      getItems(
        connection.uuid,
        rightPath || connection.tc_root_folder_uuid,
        "trimble"
      )
        .then((res) => {
          setRightFolders(res);
        })
        .catch(() => {})
        .finally(() => setIsRightLoading(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rightPath]);

  useEffect(() => {
    fetchTrimbleList();
  }, [fetchTrimbleList]);

  const syncLabel = (syncWay: string) => {

    if (syncWay === "TC_TO_IK") {
      return "Trimble to Infrakit";
    }
    if (syncWay === "IK_TO_TC") {
      return "Infrakit to Trimble";
    }
  };

  const deltaLabel = (delta: number) => {
    return delta === 60 ? "1 hour" : delta === 1440 ? "1 day" : "1 week";
  };

  return (
    <div className="folder-container">
      <CssBaseline />
      <div>
        <div className="folder-button-container">
          <Button
            variant="contained"
            className="folder-button"
            onClick={logOut}
          >
            Logout
          </Button>
          <Button
            variant="contained"
            className="folder-button"
            onClick={() => {
              localStorage.removeItem("connectionUuid");
              localStorage.removeItem("infrakitProjectUuid");
              navigate("/infrakit/projects");
            }}
          >
            Change Infrakit Project
          </Button>
          <Button
            variant="contained"
            className="folder-button"
            onClick={() => {
              localStorage.removeItem("connectionUuid");
              navigate("/connections");
            }}
          >
            Change connection
          </Button>

          {mapped && (
            <div className="mapped">
              <p className="m-0">
                {connection.mapping?.isMapped}{" "}
                {formatDateAndTime(connection.mapping?.updateDate)}
              </p>
              <div
                className="ml-3 link-text"
                onClick={() => setDetailsOpen(true)}
              >
                More details
              </div>
            </div>
          )}
        </div>
        {connection.mapping?.autoSync && (
          <div className="flex-right m-0">
            <Chip
              className="mr-1"
              style={{ borderRadius: "5px", marginTop: "3px" }}
              size="small"
              label="Auto Syncing"
              color="success"
              variant="outlined"
            />
            <CButton
              className="btn"
              disabled={isLoading}
              onClick={() =>
                openPopup("Do you want to stop auto syncing?", "stop")
              }
              style={{ padding: "5px", backgroundColor: "#d32f2f" }}
            >
              Stop
            </CButton>
          </div>
        )}
        <h3 className="unmapped-header m-1">
          Connection name: {connection.name}
        </h3>
        {mapped ? (
          <div className="unmapped-header">
            <Button
              variant="contained"
              className="folder-button"
              onClick={() => {
                const message =
                  getLastFolderName(leftPath) +
                  " - " +
                  getLastFolderName(rightPath);
                openPopup(
                  `Do you want to synchronize those two folders: ${message}`,
                  "sync"
                );
              }}
            >
              Sync
            </Button>
          </div>
        ) : (
          <div className="unmapped-header">
            <h3>Chose folders you want to map</h3>
          </div>
        )}
      </div>

      <div className="header">
        <h1>Infrakit</h1>
        {mapped ? (
          <div className="header-text">
            <div className="flex-container">
              <h4 style={{ margin: "10px", textAlign: "right" }}>
                {connection.mapping?.infraFolderName}
              </h4>
              <Button
                variant="contained"
                color="error"
                onClick={() =>
                  openPopup("Do you want to unmap folders?", "unmap")
                }
              >
                Unmap
              </Button>
              <h4 style={{ margin: "10px", textAlign: "left" }}>
                {connection.mapping?.trimbleFolderName}
              </h4>
            </div>
          </div>
        ) : (
          <Button
            variant="contained"
            className="folder-button"
            onClick={() => {
              const message =
                getLastFolderName(leftPath) +
                " - " +
                getLastFolderName(rightPath);
              openPopup(
                `Do you want to map those two folders: ${message}`,
                "connect"
              );
            }}
            disabled={!rightPath.includes("/") || !leftPath.includes("/")}
          >
            Map
          </Button>
        )}
        <h1 style={{ textAlign: "right" }}>Trimble</h1>
      </div>

      <div className="app-body">
        <div className="left-div">
          <div id="explorer-info-wrapper">
            <Loader isLoading={isLeftLoading} fullWidth>
              <FilesExplorer
                path={leftPath}
                currentId={leftUuid}
                items={leftFolders}
                onSelect={(path: string, uuid: string) => {
                  setLeftUuid(uuid);
                  setLeftPath(path);
                }}
                setFolderPath={(path: string, uuid: string) => {
                  setLeftPath(path);
                  setLeftUuid(uuid);
                }}
              />
            </Loader>
          </div>
        </div>

        <div className="right-div">
          <div id="explorer-info-wrapper">
            <Loader isLoading={isRightLoading} fullWidth>
              <FilesExplorer
                path={rightPath}
                items={rightFolders}
                onSelect={(path: string, uuid: string) => {
                  setRightPath(path);
                  setRightUuid(uuid);
                }}
                setFolderPath={(path: string) => setRightPath(path)}
              />
            </Loader>
          </div>
        </div>
      </div>
      {isLoading && <FullScreenLoader isLoading />}
      <Popup
        show={showPopup}
        message={popupMessage}
        loading={popupLoading}
        children={
          popupCallback === "sync" ? (
            <div>
              <p>Sync direction: </p>
              <Select
                value={
                  syncWay
                    ? {
                        value: syncWay,
                        label: syncLabel(syncWay),
                      }
                    : null
                }
                options={["TC_TO_IK", "IK_TO_TC"].map((e) => ({
                  value: e,
                  label: syncLabel(e),
                }))}
                onChange={(e) => {
                  setSyncWay(e?.value || "TC_TO_IK");
                }}
              />
              <Alert severity="info" className="mt-3">
                Files larger than 500 MB will not be synchronized.
              </Alert>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={autoSyncChecked}
                    onChange={(e) => setAutoSyncChecked(e.target.checked)}
                  />
                }
                label="Enable auto syncing"
              />
              {autoSyncChecked && (
                <Select
                  value={
                    delta
                      ? {
                          value: delta,
                          label: deltaLabel(delta),
                        }
                      : null
                  }
                  options={[60, 1440, 10080].map((e) => ({
                    value: e,
                    label: deltaLabel(e),
                  }))}
                  onChange={(e) => {
                    setDelta(e?.value || 60);
                  }}
                />
              )}
            </div>
          ) : undefined
        }
        onClose={() => {
          setShowPopup(false);
          setSyncWay("TC_TO_IK");
          setAutoSyncChecked(false);
          setDelta(60);
        }}
        onConfirm={() => {
          popupCallback === "sync" ? sync(autoSyncChecked, delta) : handleOk();
        }}
      />
      <Popup
        show={detailsOpen}
        title={"Sync details"}
        children={
          <div style={{ textAlign: "left" }}>
            <strong>Status:</strong> {connection.mapping?.isMapped}
            <p>
              <strong>Date:</strong>{" "}
              {formatDateAndTime(connection.mapping?.updateDate)}
            </p>
            <p>
              <strong>Sync way:</strong> {syncLabel(connection.mapping?.way)}
            </p>
            <p>
              <strong>Synced:</strong>{" "}
              {(connection.mapping?.syncedFiles || 0) +
                " / " +
                (connection.mapping?.totalFiles || 0)}{" "}
              files
            </p>
            {!!connection.mapping?.bigFiles && (
              <>
                <p>
                  <strong>Files that are too large to sync:</strong>
                </p>
                <ul>
                  {connection.mapping?.bigFiles
                    .split(",")
                    .map((item: string, index: number) => (
                      <li key={index}>{item}</li>
                    ))}
                </ul>
              </>
            )}
            {!!connection.mapping?.invalidFiles && (
              <>
                <p>
                  <strong>Invalid Files</strong>
                </p>
                <ul>
                  {connection.mapping?.invalidFiles
                    .split(":")
                    .map((item: string, index: number) => (
                      <li key={index}>{item}</li>
                    ))}
                </ul>
              </>
            )}
          </div>
        }
        onClose={() => setDetailsOpen(false)}
      />
      <SyncStatus
        show={isSyncing}
        onCheck={() => {
          checkStatus();
        }}
        syncStatusAdditionalMessage={
          !!connection.mapping?.totalFiles ? (
            <p>
              <strong>Synced:</strong>{" "}
              {(connection.mapping?.syncedFiles || 0) +
                " / " +
                connection.mapping?.totalFiles}{" "}
              items
            </p>
          ) : (
            ""
          )
        }
      />
    </div>
  );
};

const getLastFolderName = (path: string) => {
  const lastIndex: number = path.lastIndexOf("/");
  let name: string = "";

  if (lastIndex !== -1) {
    name = path.substring(lastIndex + 1);
  }

  return name;
};
